import { Bracket } from "react-brackets";
import React, { useState, useEffect } from "react";
import {
  SeedStyle,
  SeedItemStyle,
  SeedTeamStyle,
  Score,
  Flag,
  TBA,
  getRosterNames,
  TeamMeta,
  TeamName,
  TeamRoster,
  ManageMatch,
  ModalContainer,
  ModalIcon,
  Header,
  Description,
  Footer,
  Buttons,
} from "./SingleElimination";
import Modal from "./Modal";
import { ReactComponent as StartGameIcon } from "../img/icons/playGame.svg";
import { ReactComponent as EndGameIcon } from "../img/icons/endGame.svg";
import startGameIcon from "../img/icons/playGame.svg";
import endGameIcon from "../img/icons/endGame.svg";
import Button from "./Button";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import ScrollContainer from "react-indiana-drag-scroll";

const HandleConfirm = ({ hideModal, action, seed, roundIndex, seedIndex }) => {
  const description = () => {
    if (action === "Start") {
      return (
        "Start the game between " +
        seed.teams[0].player.name.toUpperCase() +
        " and " +
        seed.teams[1].player.name.toUpperCase() +
        " ?"
      );
    } else if (action === "End" && seed.teams[0].score !== seed.teams[1].score)
      return (
        "End the game between " +
        seed.teams[0].player.name.toUpperCase() +
        " and " +
        seed.teams[1].player.name.toUpperCase() +
        " ?"
      );
    else if (action === "End" && seed.teams[0].score === seed.teams[1].score) {
      return "Score is equal!";
    } else if (action === "Select") {
      return "Select this Team ?";
    }
  };
  const title = action === "Select" ? "Select player" : action + " The game";
  const buttonText = action === "Select" ? action : action + " game";
  const { id } = useParams();
  return (
    <ModalContainer>
      <Header>
        <ModalIcon src={action === "End" ? endGameIcon : startGameIcon} />
        <h4>{title}</h4>
      </Header>
      <Footer>
        <Description>{description()}</Description>
      </Footer>
      <Buttons>
        <Button size="small" onClick={hideModal}>
          Cancel
        </Button>
        <Button
          size="small"
          variant="primary"
          onClick={async () => {
            let winnerID = 0;
            let matchID = seed.id;
            let scorePlayer1 = 0;
            let scorePlayer2 = 0;
            if (action === "Start") {
              seed.playing = true;
              seed.finished = false;
              seed.teams[0].score = parseInt(0);
              seed.teams[1].score = parseInt(0);
              axios.post(process.env.REACT_APP_START_MATCH_ENDPOINT + matchID).then((x) => {
                if (seed.playing) seed.finished = false;
              });
            } else if (action === "End" && seed.teams[0].score !== seed.teams[1].score) {
              matchID = seed.id;
              if (seed.teams[0].score > seed.teams[1].score) {
                // rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[0].player;
                winnerID = seed.teams[0].playerID;
                // rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[0].player;
              }
              if (seed.teams[0].score < seed.teams[1].score) {
                // rounds[roundIndex + 1].seeds[parseInt(seedIndex / 2)].teams[seedIndex % 2 ? 1 : 0].player = seed.teams[1].player;
                winnerID = seed.teams[1].playerID;
              }
              scorePlayer1 = parseInt(seed.teams[0].score);
              scorePlayer2 = parseInt(seed.teams[1].score);
              seed.finished = true;
              seed.playing = false;
              try {
                if (isNaN(scorePlayer1)) scorePlayer1 = parseInt(0);
                if (isNaN(scorePlayer2)) scorePlayer2 = parseInt(0);
                console.log(scorePlayer1, scorePlayer2);
                await axios.post(
                  process.env.REACT_APP_TOURNAMENT_SET_WINNER_ENDPOINT,
                  { matchID, winnerID, tournmentID: id, scorePlayer1, scorePlayer2 },
                  { withCredentials: true }
                );
              } catch (e) {
                console.log(e);
              }
              if (seed.finished) seed.playing = false;
            }
            hideModal();
          }}
        >
          {action === "End"
            ? seed.teams[0]?.score === seed.teams[1]?.score
              ? ""
              : buttonText
            : buttonText}
        </Button>
      </Buttons>
    </ModalContainer>
  );
};

export const CustomSeed = ({ seed, breakpoint, roundIndex, seedIndex }) => {
  const [confirmModal, setConfirmModal] = useState(false);
  // const [newScore, setNewScore] = useState({ score: parseInt(0), team: null });
  const [checkVal, setCheckVal] = useState();
  const hideModal = () => setConfirmModal(false);
  const { id } = useParams();

  const [admin, setAdmin] = useState(null);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_TOURNAMENT_IS_ADMIN_ENDPOINT + id, { withCredentials: true })
      .then((res) => {
        setAdmin(res.data && !window.stream);
      })
      .catch((err) => console.log(err));
  }, [id]);
  return (
    <SeedStyle mobileBreakpoint={breakpoint}>
      {admin ? (
        <Modal isOpen={confirmModal} onRequestClose={hideModal} hideModal={hideModal}>
          <HandleConfirm
            hideModal={hideModal}
            roundIndex={roundIndex}
            seedIndex={seedIndex}
            action={checkVal}
            seed={seed}
          />
        </Modal>
      ) : (
        ""
      )}
      <SeedItemStyle>
        {admin && seed.teams[0]?.player && seed.teams[1]?.player ? (
          <ManageMatch>
            {!seed.playing && !seed.finished ? (
              <Button
                style={{ margin: "0 auto 4px" }}
                icon
                onClick={() => {
                  setCheckVal("Start");
                  setConfirmModal(true);
                }}
              >
                <StartGameIcon />
              </Button>
            ) : (
              ""
            )}
            {seed.playing && !seed.finished ? (
              <Button
                style={{ margin: "0 auto 4px" }}
                icon
                onClick={() => {
                  setCheckVal("End");
                  setConfirmModal(true);
                }}
              >
                <EndGameIcon />
              </Button>
            ) : (
              ""
            )}
          </ManageMatch>
        ) : (
          ""
        )}
        <div>
          <SeedTeamStyle
            finished={seed.finished}
            playing={seed.playing}
            first={true}
            winner={seed.teams[0].score >= seed.teams[1].score}
          >
            {seed.teams[0]?.player ? (
              <>
              {seed.teams[0].player.avatar ? <Flag src={seed.teams[0].player.avatar} alt="" /> : null}
                <TeamMeta>
                  <TeamName>{seed.teams[0]?.player.name}</TeamName>
                  {getRosterNames(seed.teams[0]?.player).length > 0 && (
                    <TeamRoster>{getRosterNames(seed.teams[0]?.player).join(", ")}</TeamRoster>
                  )}
                </TeamMeta>
                <Score
                  disabled={seed.finished || !admin || (!seed.finished && !seed.playing)}
                  value={parseInt(seed.teams[0].score) || parseInt(0)}
                  type="number"
                  onChange={(e) => {
                    seed.teams[0].score = parseInt(e.target.value);
                    console.log(typeof parseInt(e.target.value));
                    // setNewScore({
                    //     score: parseInt(e.target.value),
                    //     team: seed.teams[0],
                    // })
                  }}
                />
              </>
            ) : (
              <TBA admin={admin}>{admin ? "SELECT" : "TBA"}</TBA>
            )}
          </SeedTeamStyle>
          <SeedTeamStyle
            finished={seed.finished}
            playing={seed.playing}
            winner={seed.teams[0].score <= seed.teams[1].score}
          >
            {seed.teams[1]?.player ? (
              <>
              {seed.teams[1].player.avatar ? <Flag src={seed.teams[1].player.avatar} alt="" /> : null}
                <TeamMeta>
                  <TeamName>{seed.teams[1]?.player.name}</TeamName>
                  {getRosterNames(seed.teams[1]?.player).length > 0 && (
                    <TeamRoster>{getRosterNames(seed.teams[1]?.player).join(", ")}</TeamRoster>
                  )}
                </TeamMeta>
                <Score
                  disabled={seed.finished || !admin || (!seed.finished && !seed.playing)}
                  value={parseInt(seed.teams[1].score) || parseInt(0)}
                  type="number"
                  onChange={(e) => {
                    seed.teams[1].score = parseInt(e.target.value);
                    // setNewScore({
                    //     score: parseInt(e.target.value),
                    //     team: seed.teams[1],
                    // })
                  }}
                />
              </>
            ) : (
              <TBA admin={admin}>{admin ? "SELECT" : "TBA"}</TBA>
            )}
          </SeedTeamStyle>
        </div>
      </SeedItemStyle>
    </SeedStyle>
  );
};
const DoubleElimination = () => {
  window.stream = true;
  const rounds = useSelector((state) => state.rounds);
  const [winnerBracket, setWinnerBracket] = useState(rounds ? rounds?.data?.winnerBracket : null);
  const [loserBracket, setLoserBracket] = useState(rounds ? rounds?.data?.LoserBracket : null);
  useEffect(() => {
    setWinnerBracket(rounds ? rounds?.data?.winnerBracket : null);
    setLoserBracket(rounds ? rounds?.data?.LoserBracket : null);
  }, [rounds]);
  console.log(rounds)
  return (
    <ScrollContainer style={{ marginBottom: "40px" }} horizontal={true} vertical={true}>
      {winnerBracket && winnerBracket !== undefined ? (
        <Bracket mobileBreakpoint={0} rounds={winnerBracket} renderSeedComponent={CustomSeed} />
      ) : (
        <></>
      )}
      {loserBracket && loserBracket !== undefined ? (
        <Bracket mobileBreakpoint={0} rounds={loserBracket} renderSeedComponent={CustomSeed} />
      ) : (
        <></>
      )}
    </ScrollContainer>
  );
};

export default DoubleElimination;
